import { ERP } from '../_base/endpoint';
import axios from 'axios';

class motivoNotaDebitoService {
    
    /******* QUERIES ******/

    async listar() {
        const response = await axios
            .get(`${ERP}administracion/motivo-nota-debito`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
}

export default new motivoNotaDebitoService();